import {
  Avatar,
  Box,
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Skeleton,
  Text,
  useDisclosure,
  useTheme,
  useToast,
  Image,
} from "@chakra-ui/react";
import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Theme } from "../../theme";
import getAxios from "../../hooks/useAxios";
import Cookies from "js-cookie";
import config from "../../config";
import Input from "../../components/CustomInput";
import ImagePreviewModal from "../../components/ImagePreview";

export interface DriverDetails {
  id: string;
  mobile: string;
  name: string;
  is_blocked: boolean;
  is_finished_onboarding: boolean;
  is_approved: boolean;
  created_at: string;
  updated_at: string;
  documents: Documents;
  driving_area: string;
  vehicle_details: VehicleDetails;
  on_duty: boolean;
  location: Location;
}

export interface Documents {
  pan_back: string;
  pan_front: string;
  aadhaar_front: string;
  aadhaar_back: string;
  driving_licence_front: string;
  driving_licence_back: string;
  vehicle_rc_front: string;
  vehicle_rc_back: string;
  profile_picture: string;
}

export interface VehicleDetails {
  registration_number: string;
  make: string;
  model: string;
  type: string;
}

export interface Location {
  current: Current;
}

export interface Current {
  type: string;
  coordinates: number[];
}

const DriverDetails = () => {
  let [searchParams] = useSearchParams();
  const theme = useTheme<Theme>();
  const navigate = useNavigate();
  const toast = useToast();
  const axios = getAxios();
  const id = searchParams.get("id");
  const token = Cookies.get("x-admin-auth");
  const [driver, setDriver] = React.useState<DriverDetails>();
  const [loaded, setLoaded] = React.useState(false);
  const [userFetchName, setUserFetchName] = React.useState<string>("initial");
  const [dpImage, setDpFImage] = React.useState<string>();
  const [idFImage, setIdFImage] = React.useState<string>();
  const [idBImage, setIdBImage] = React.useState<string>();
  const [rcFImage, setRcFImage] = React.useState<string>();
  const [rcBImage, setRcBImage] = React.useState<string>();
  const [dlFImage, setDlFImage] = React.useState<string>();
  const [dlBImage, setDlBImage] = React.useState<string>();
  const [dpImageLoaded, setDpImageLoaded] = React.useState(false);
  const [idFImageLoaded, setIdFImageLoaded] = React.useState(false);
  const [idBImageLoaded, setIdBImageLoaded] = React.useState(false);
  const [rcFImageLoaded, setRcFImageLoaded] = React.useState(false);
  const [rcBImageLoaded, setRcBImageLoaded] = React.useState(false);
  const [dlFImageLoaded, setDlFImageLoaded] = React.useState(false);
  const [dlBImageLoaded, setDlBImageLoaded] = React.useState(false);
  const [ratings, setRatings] = React.useState<any>();
  const [blockedReason, setBlockedReason] = React.useState("");
  const [blockedLoading, setBlockedLoading] = React.useState(false);
  const [unblockedLoading, setUnBlockedLoading] = React.useState(false);
  const [approvalLoading, setApprovalLoading] = React.useState(false);
  const [modalId, setModalId] = React.useState<string>();
  const [deleteLoading, setDeleteLoading] = React.useState(false);
  const [blockedReasonRequired, setBlockedReasonRequired] =
    React.useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isUnblockOpen,
    onOpen: onUnblockOpen,
    onClose: onUnblockClose,
  } = useDisclosure();
  const {
    isOpen: isApproveOpen,
    onOpen: onApproveOpen,
    onClose: onApproveClose,
  } = useDisclosure();
  const {
    isOpen: isDeleteOpen,
    onOpen: onDeleteOpen,
    onClose: onDeleteClose,
  } = useDisclosure();

  React.useEffect(() => {
    if (id) {
      getDriverDetails(id);
      getUserRatings(id);
    }
  }, [id, userFetchName]);

  const getDriverDetails = async (id: string) => {
    const res = await axios.get<DriverDetails>(`/drivers/${id}`);
    console.log("resss", res.data);
    setDriver(res.data);
    if (res.data.documents) {
      await getImageLink(res.data.documents.profile_picture, "dp").then(
        (img) => {
          setDpFImage(img);
        },
      );
      await getImageLink(res.data.documents.driving_licence_front, "dlF").then(
        (img) => {
          setDlFImage(img);
        },
      );
      await getImageLink(res.data.documents.driving_licence_back, "dlB").then(
        (img) => {
          setDlBImage(img);
        },
      );
      await getImageLink(res.data.documents.vehicle_rc_front, "rcF").then(
        (img) => {
          setRcFImage(img);
        },
      );
      await getImageLink(res.data.documents.vehicle_rc_back, "rcB").then(
        (img) => {
          setRcBImage(img);
        },
      );
      if (res.data.documents.aadhaar_front !== "") {
        await getImageLink(res.data.documents.aadhaar_front, "idF").then(
          (img) => {
            setIdFImage(img);
          },
        );
      }
      if (res.data.documents.aadhaar_back !== "") {
        await getImageLink(res.data.documents.aadhaar_back, "idB").then(
          (img) => {
            setIdBImage(img);
          },
        );
      }
      if (res.data.documents.pan_front !== "") {
        await getImageLink(res.data.documents.pan_front, "idF").then((img) => {
          setIdFImage(img);
        });
      }
      if (res.data.documents.pan_back !== "") {
        await getImageLink(res.data.documents.pan_back, "idB").then((img) => {
          setIdBImage(img);
        });
      }
    } else {
      setDlBImageLoaded(true);
      setDlFImageLoaded(true);
      setIdBImageLoaded(true);
      setIdFImageLoaded(true);
      setRcBImageLoaded(true);
      setRcFImageLoaded(true);
    }
    setLoaded(true);
  };

  const getUserRatings = async (id: string) => {
    try {
      const res = await axios.get(`/ratings/drivers/${id}`);
      console.log("fgfgfgfgfgfgfgfgf", res.data);

      const totalRating = Number(res.data?.total_rating) || 0;
      const ratingCount = Number(res.data?.rating_count) || 0;
      const ratings = ratingCount > 0 ? totalRating / ratingCount : 0;
      setRatings(ratings.toFixed(1));
    } catch (error) {
      console.log("error fetching ratings", error);
    }
  };

  function arrayBufferToBase64(buffer: any) {
    let binary = "";
    let bytes = new Uint8Array(buffer);
    let len = bytes.length;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary);
  }

  const getImageLink = async (url: string, name: string) => {
    try {
      const res = await axios.get(`uploads/${url}?token=${token}`, {
        responseType: "arraybuffer",
      });
      const buffer = res.data;
      let base64String = arrayBufferToBase64(buffer);
      let dataUri = "data:image/jpeg;base64," + base64String;
      return dataUri;
    } catch (error) {
      console.log("error", error);
    } finally {
      switch (name) {
        case "dlF":
          setDlFImageLoaded(true);
          break;
        case "dlB":
          setDlBImageLoaded(true);
          break;
        case "rcF":
          setRcFImageLoaded(true);
          break;
        case "rcB":
          setRcBImageLoaded(true);
          break;
        case "idF":
          setIdFImageLoaded(true);
          break;
        case "idB":
          setIdBImageLoaded(true);
          break;
        case "dp":
          setDpImageLoaded(true);
          break;
      }
    }
  };

  async function handleApproveButton(id: string) {
    setApprovalLoading(true);
    try {
      const res = await axios.get(`/drivers/${id}/approve`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      onApproveClose();
      setUserFetchName(`refetch_${Math.random()}`);
      return toast({
        position: "top",
        title: "Driver approved",
        description: (
          <Text variant={"caption"} color="white">
            Changes were successfully reflected
          </Text>
        ),
        status: "success",
        duration: 5000,
        isClosable: true,
      });
    } catch (error) {
      console.log("error approving", error);
    } finally {
      setApprovalLoading(false);
    }
  }

  async function handleUnblockButton(id: string) {
    setUnBlockedLoading(true);
    try {
      const res = await axios.get(`/drivers/${id}/unblock`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      onUnblockClose();
      setUserFetchName(`refetch_${Math.random()}`);
      return toast({
        position: "top",
        title: "Driver unblocked.",
        description: (
          <Text variant={"caption"} color="white">
            Changes were successfully reflected
          </Text>
        ),
        status: "success",
        duration: 5000,
        isClosable: true,
      });
    } catch (error) {
      console.log("error unblocking", error);
    } finally {
      setUnBlockedLoading(false);
    }
  }

  async function handleBlockButton(id: string) {
    setBlockedReasonRequired(false);
    setBlockedLoading(true);
    if (blockedReason === "") {
      setBlockedReasonRequired(true);
      setBlockedLoading(false);
    } else {
      setBlockedReasonRequired(false);
      try {
        const res = await axios.get(`/drivers/${id}/block`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        onClose();
        setUserFetchName(`refetch_${Math.random()}`);
        return toast({
          position: "top",
          title: "Driver blocked.",
          description: (
            <Text variant={"caption"} color="white">
              Changes were successfully reflected
            </Text>
          ),
          status: "success",
          duration: 5000,
          isClosable: true,
        });
      } catch (error) {
        console.log("error blocking", error);
      } finally {
        setBlockedLoading(false);
      }
    }
  }

  async function handleDeleteButton(id: string) {
    setDeleteLoading(true);
    try {
      await axios.delete(`/drivers/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      onDeleteClose();
      navigate({
        pathname: "/drivers",
      });
      return toast({
        position: "top",
        title: "Driver deleted.",
        description: (
          <Text variant={"caption"} color="white">
            Changes were successfully reflected
          </Text>
        ),
        status: "success",
        duration: 5000,
        isClosable: true,
      });
    } catch (error) {
      console.log("error while deleting", error);
    } finally {
      setDeleteLoading(false);
    }
  }

  return (
    <Box sx={{ padding: "1rem" }}>
      <Box
        bg="white"
        borderRadius="10px"
        border="1px solid"
        borderColor="gray.200"
        style={{
          width: "100%",
          margin: "1rem auto",
          boxShadow: "0px 0px 10px rgba(0,0,0,0.1)",
          borderRadius: "10px",
        }}
      >
        <Flex
          sx={{
            borderBottom: "1px solid",
            borderColor: theme.colors.divider,
            padding: "0.75rem 1.25rem",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Text sx={{ fontSize: "1.25rem", fontWeight: 900 }}>
            Driver Details
          </Text>
          <Flex sx={{ gap: "1.5rem" }}>
            {driver && !driver.is_approved && (
              <Text
                sx={{
                  fontSize: "1rem",
                  fontWeight: 900,
                  color: theme.colors.primary.main,
                  cursor: "pointer",
                }}
                onClick={() => {
                  if (driver) {
                    onApproveOpen();
                    setModalId(driver.id);
                  }
                }}
              >
                Approve Driver
              </Text>
            )}
            {driver && (
              <Text
                sx={{
                  fontSize: "1rem",
                  fontWeight: 900,
                  color: theme.colors.primary.main,
                  cursor: "pointer",
                }}
                onClick={() => {
                  if (driver) {
                    if (driver.is_blocked) {
                      onUnblockOpen();
                      setModalId(driver.id);
                    } else {
                      onOpen();
                      setModalId(driver.id);
                    }
                  }
                }}
              >
                {driver.is_blocked ? "Unblock Driver" : "Block Driver"}
              </Text>
            )}
            <Text
              sx={{
                fontSize: "1rem",
                fontWeight: 900,
                color: theme.colors.primary.main,
                cursor: "pointer",
              }}
              onClick={() => {
                if (driver) {
                  onDeleteOpen();
                  setModalId(driver.id);
                }
              }}
            >
              {"Delete Driver"}
            </Text>
          </Flex>
        </Flex>
        <Flex
          sx={{
            padding: "1.25rem 0 1rem 1.25rem",
          }}
        >
          <Flex sx={{ flex: 1, gap: "1rem", alignItems: "center" }}>
            <Box sx={{ position: "relative", width: "max-content" }}>
              <Avatar
                size={"xl"}
                name={driver?.name}
                src={dpImage}
                style={{
                  border: "2px solid #800020",
                }}
              />
              <Box
                sx={{
                  position: "absolute",
                  padding: "0 0.125rem 0 0.5rem",
                  borderRadius: "0.5rem",
                  border: `2px solid ${theme.colors.primary.main}`,
                  background: "#FFFFFF",
                  bottom: "-10%",
                  left: "50%",
                  transform: "translate(-50%,0)",
                  width: "max-content",
                }}
              >
                <Flex sx={{ alignItems: "center" }}>
                  <Text
                    sx={{
                      color: theme.colors.primary.main,
                      fontSize: "0.85rem",
                      fontWeight: 900,
                    }}
                  >
                    {ratings ?? "--"}
                  </Text>
                  <Image
                    src={"/StarFilled.png"}
                    alt="No Images"
                    aspectRatio={1 / 1}
                    width="1.5rem"
                  />
                </Flex>
              </Box>
            </Box>
            <Box
              sx={{
                padding: "0.25rem 0.5rem",
                borderRadius: "0.5rem",
                border: `2px solid ${theme.colors.primary.main}`,
              }}
            >
              <Text
                sx={{
                  fontWeight: 600,
                  color: driver?.on_duty
                    ? theme.colors.success
                    : theme.colors.secondary.light,
                }}
              >
                {driver?.on_duty ? "ON DUTY" : "OFF DUTY"}
              </Text>
            </Box>
          </Flex>
          <Flex sx={{ flex: 1, justifyContent: "flex-end" }}>
            <Box
              sx={{
                marginRight: "1rem",
                padding: "0.5rem 1rem",
                cursor: "pointer",
                width: "max-content",
                height: "max-content",
                border: "1px solid",
                borderColor: theme.colors.primary.main,
                borderRadius: "0.5rem",
              }}
              onClick={() => {
                navigate({
                  pathname: "/drivers/history",
                  search: `?id=${id}`,
                });
              }}
            >
              <Text
                sx={{
                  fontSize: "1rem",
                  fontWeight: 900,
                  color: theme.colors.primary.main,
                }}
              >
                View History
              </Text>
            </Box>
          </Flex>
        </Flex>
        <Flex
          sx={{
            padding: "1.25rem",
          }}
        >
          <Box sx={{ flex: 1 }}>
            <Flex sx={{ gap: "0.5rem" }}>
              <Text sx={{ color: theme.colors.secondary.light }}>Name:</Text>
              <Text sx={{ fontWeight: 600 }}>{driver?.name}</Text>
            </Flex>
            <Flex sx={{ gap: "0.5rem" }}>
              <Text sx={{ color: theme.colors.secondary.light }}>
                Phone Number:
              </Text>
              <Text sx={{ fontWeight: 600 }}>{driver?.mobile}</Text>
            </Flex>

            <Flex sx={{ gap: "0.5rem" }}>
              <Text sx={{ color: theme.colors.secondary.light }}>Vehicle:</Text>
              <Text sx={{ fontWeight: 600 }}>
                {driver?.vehicle_details
                  ? driver?.vehicle_details?.make +
                    " " +
                    driver?.vehicle_details?.model
                  : " --"}
              </Text>
            </Flex>

            <Flex sx={{ gap: "0.5rem" }}>
              <Text sx={{ color: theme.colors.secondary.light }}>
                Vehicle Registration Id:
              </Text>
              <Text sx={{ fontWeight: 600 }}>
                {driver?.vehicle_details?.registration_number || "   --"}
              </Text>
            </Flex>
          </Box>
          <Box sx={{ flex: 1 }}>
            <Flex sx={{ gap: "0.5rem" }}>
              <Text sx={{ color: theme.colors.secondary.light }}>
                Joining Date:
              </Text>
              <Text sx={{ fontWeight: 600 }}>
                {(driver &&
                  new Date(driver.created_at).toLocaleDateString("en-IN")) ||
                  "   --"}
              </Text>
            </Flex>
            <Flex sx={{ gap: "0.5rem" }}>
              <Text sx={{ color: theme.colors.secondary.light }}>
                Account Status:
              </Text>
              <Text
                sx={{
                  fontWeight: 600,
                  color: driver?.is_blocked
                    ? theme.colors.error
                    : theme.colors.success,
                }}
              >
                {driver?.is_blocked ? "Blocked" : "Active"}
              </Text>
            </Flex>
            <Flex sx={{ gap: "0.5rem" }}>
              <Text sx={{ color: theme.colors.secondary.light }}>
                On Boarding Status:
              </Text>
              <Text
                sx={{
                  fontWeight: 600,
                  color: driver?.is_finished_onboarding
                    ? theme.colors.success
                    : theme.colors.warning,
                }}
              >
                {driver?.is_finished_onboarding ? "Completed" : "Pending"}
              </Text>
            </Flex>

            <Flex sx={{ gap: "0.5rem" }}>
              <Text sx={{ color: theme.colors.secondary.light }}>
                Documentation Approval:
              </Text>
              <Text
                sx={{
                  fontWeight: 600,
                  color: driver?.is_approved
                    ? theme.colors.success
                    : theme.colors.warning,
                }}
              >
                {driver?.is_approved ? "Approved" : "Not Approved"}
              </Text>
            </Flex>

            {/* <Flex sx={{ gap: "0.5rem" }}>
              <Text sx={{ color: theme.colors.secondary.light }}>
                Duty Status:
              </Text>
              <Text sx={{ fontWeight: 600 }}>
                {driver?.on_duty ? "On Duty" : "Off Duty"}
              </Text>
            </Flex> */}
          </Box>
        </Flex>
      </Box>

      <Flex sx={{ gap: "1rem" }}>
        <Box
          bg="white"
          borderRadius="10px"
          border="1px solid"
          borderColor="gray.200"
          style={{
            flex: 1,
            margin: "1rem auto",
            boxShadow: "0px 0px 10px rgba(0,0,0,0.1)",
            borderRadius: "10px",
          }}
        >
          <Flex
            sx={{
              borderBottom: "1px solid",
              borderColor: theme.colors.divider,
              padding: "0.75rem 1.25rem",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Text sx={{ fontSize: "1.25rem", fontWeight: 900 }}>
              Driver Documents
            </Text>
          </Flex>
          <Box sx={{ padding: "1.25rem" }}>
            <Box sx={{ marginBottom: "1rem" }}>
              <Box
                style={{
                  fontSize: "1rem",
                  fontWeight: "bold",
                  color: "#333",
                }}
              >
                Driving License
              </Box>
              <Box
                style={{
                  display: "flex",
                  gap: "1rem",
                  flexWrap: "wrap",
                }}
              >
                <DocCard
                  image={dlFImage}
                  imageLoaded={dlFImageLoaded}
                  imageSide="Front"
                />
                <DocCard
                  image={dlBImage}
                  imageLoaded={dlBImageLoaded}
                  imageSide="Back"
                />
              </Box>
            </Box>

            <Box sx={{ marginBottom: "1rem" }}>
              <Box
                style={{
                  fontSize: "1rem",
                  fontWeight: "bold",
                  color: "#333",
                }}
              >
                Vehicle RC
              </Box>
              <Box
                style={{
                  display: "flex",
                  gap: "1rem",
                  flexWrap: "wrap",
                }}
              >
                <DocCard
                  image={rcFImage}
                  imageLoaded={rcFImageLoaded}
                  imageSide="Front"
                />
                <DocCard
                  image={rcBImage}
                  imageLoaded={rcBImageLoaded}
                  imageSide="Back"
                />
              </Box>
            </Box>

            <Box sx={{ marginBottom: "1rem" }}>
              <Box
                style={{
                  fontSize: "1rem",
                  fontWeight: "bold",
                  color: "#333",
                }}
              >
                ID Proof
              </Box>
              <Box
                style={{
                  display: "flex",
                  gap: "1rem",
                  flexWrap: "wrap",
                }}
              >
                <DocCard
                  image={idFImage}
                  imageLoaded={idFImageLoaded}
                  imageSide="Front"
                />
                <DocCard
                  image={idBImage}
                  imageLoaded={idBImageLoaded}
                  imageSide="Back"
                />
              </Box>
            </Box>
          </Box>
        </Box>
        <Box
          bg="white"
          borderRadius="10px"
          border="1px solid"
          borderColor="gray.200"
          style={{
            flex: 1,
            margin: "1rem auto",
            boxShadow: "0px 0px 10px rgba(0,0,0,0.1)",
            borderRadius: "10px",
            maxHeight: "max-content",
          }}
        >
          <Flex
            sx={{
              borderBottom: "1px solid",
              borderColor: theme.colors.divider,
              padding: "0.75rem 1.25rem",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Text sx={{ fontSize: "1.25rem", fontWeight: 900 }}>
              Driver Location
            </Text>
            <Text
              sx={{
                fontSize: "1rem",
                fontWeight: 900,
                color: theme.colors.primary.main,
                cursor: "pointer",
              }}
              onClick={() => {
                setUserFetchName(`fetch_${Math.random()}`);
              }}
            >
              Get Current Location
            </Text>
          </Flex>
          <Box sx={{ padding: "1rem" }}>
            {driver && driver.location && driver.location.current ? (
              <>
                <iframe
                  width="100%"
                  height="400px"
                  frameBorder="0"
                  style={{ border: "0" }}
                  src={`https://www.openstreetmap.org/export/embed.html?bbox=${
                    driver?.location.current.coordinates[0] - 0.01
                  },${driver?.location.current.coordinates[1] - 0.01},${
                    driver?.location.current.coordinates[0] + 0.01
                  },${
                    driver?.location.current.coordinates[1] + 0.01
                  }&layer=mapnik&marker=${driver?.location.current.coordinates[1]},${
                    driver?.location.current.coordinates[0]
                  }`}
                  allowFullScreen
                ></iframe>
              </>
            ) : (
              <Text sx={{ textAlign: "center", fontSize: "0.85rem" }}>
                Cannot Fetch Driver Location
              </Text>
            )}
          </Box>
        </Box>
      </Flex>

      <ApprovalModal
        id={modalId}
        onClose={onApproveClose}
        isOpen={isApproveOpen}
        approvalLoading={approvalLoading}
        handleApproveButton={handleApproveButton}
      />
      <BlockedModal
        id={modalId}
        onClose={onClose}
        isOpen={isOpen}
        blockedReasonRequired={blockedReasonRequired}
        blockedLoading={blockedLoading}
        handleBlockButton={handleBlockButton}
        handleOnChange={setBlockedReason}
      />
      <UnBlockedModal
        id={modalId}
        onClose={onUnblockClose}
        isOpen={isUnblockOpen}
        unblockedLoading={unblockedLoading}
        handleUnblockButton={handleUnblockButton}
      />
      <DeleteModal
        id={modalId}
        onClose={onDeleteClose}
        isOpen={isDeleteOpen}
        deleteLoading={deleteLoading}
        handleDeleteButton={handleDeleteButton}
      />
    </Box>
  );
};

export default DriverDetails;

function ApprovalModal({
  id,
  isOpen,
  onClose,
  handleApproveButton,
  approvalLoading,
}: any) {
  const theme = useTheme<Theme>();
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      closeOnOverlayClick={true}
      isCentered={true}
      size="md"
      returnFocusOnClose={false}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton
          sx={{
            borderRadius: "50%",
            background: "transparent",
            top: "5%",
            left: "93%",
            transform: "translate(-100%)",
            width: "3rem",
            height: "3rem",
            color: theme.colors.primary.main,
            //@ts-ignore
            "&:hover": {
              background: "transparent",
            },
          }}
        />
        <ModalBody sx={{ borderRadius: "0.25rem" }}>
          <Box sx={{ margin: "6rem 1.5rem 2.5rem 1.5rem" }}>
            <Box mb={theme.space.xl}>
              <Text variant={"subHeading1"}>
                Approve driver and let him start earning?
              </Text>
            </Box>
            <Box>
              <Button
                w="100%"
                h="3em"
                color={"#00E267"}
                bg="white"
                border={"1px solid #00E267"}
                borderRadius={"4px"}
                _hover={{ bg: "#00E267", color: "white" }}
                isLoading={approvalLoading}
                variant="solid"
                size="contain"
                onClick={() => {
                  handleApproveButton(id as string);
                }}
              >
                Approve
              </Button>
            </Box>
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

function BlockedModal({
  id,
  isOpen,
  onClose,
  handleBlockButton,
  handleOnChange,
  blockedReasonRequired,
  blockedLoading,
}: any) {
  const theme = useTheme<Theme>();
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      closeOnOverlayClick={true}
      isCentered={true}
      size="md"
      returnFocusOnClose={false}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton
          sx={{
            borderRadius: "50%",
            background: "transparent",
            top: "5%",
            left: "93%",
            transform: "translate(-100%)",
            width: "3rem",
            height: "3rem",
            color: theme.colors.primary.main,
            //@ts-ignore
            "&:hover": {
              background: "transparent",
            },
          }}
        />
        <ModalBody sx={{ borderRadius: "0.25rem" }}>
          <Box sx={{ margin: "6rem 1.5rem 2.5rem 1.5rem" }}>
            <Box mb={theme.space.xl}>
              <Text variant={"subHeading1"}>
                Are you sure you want to block the driver?
              </Text>
            </Box>
            <Box sx={{ marginBottom: theme.space.xxl }}>
              <Text variant={"label"} color={theme.colors.secondary.light}>
                Reason
              </Text>
              <Input
                variant="outline"
                autoComplete="off"
                type="text"
                name="reason"
                placeholder="Type you reason here"
                mb={"0.25em"}
                onChange={(e) => handleOnChange(e.target.value)}
              />
              {blockedReasonRequired && (
                <Text variant="label" color={theme.colors.error}>
                  Please fill this field!
                </Text>
              )}
            </Box>
            <Box>
              <Button
                w="100%"
                h="3em"
                color={"#E93C31"}
                bg="white"
                borderRadius={"4px"}
                border="1px solid #E93C31"
                _hover={{ bg: "#E93C31", color: "white" }}
                isLoading={blockedLoading}
                variant="solid"
                size="contain"
                onClick={() => {
                  handleBlockButton(id as string);
                }}
              >
                Block Driver
              </Button>
            </Box>
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

function UnBlockedModal({
  id,
  isOpen,
  onClose,
  handleUnblockButton,
  unblockedLoading,
}: any) {
  const theme = useTheme<Theme>();
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      closeOnOverlayClick={true}
      isCentered={true}
      size="md"
      returnFocusOnClose={false}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton
          sx={{
            borderRadius: "50%",
            background: "transparent",
            top: "5%",
            left: "93%",
            transform: "translate(-100%)",
            width: "3rem",
            height: "3rem",
            color: theme.colors.primary.main,
            //@ts-ignore
            "&:hover": {
              background: "transparent",
            },
          }}
        />
        <ModalBody sx={{ borderRadius: "0.25rem" }}>
          <Box sx={{ margin: "6rem 1.5rem 2.5rem 1.5rem" }}>
            <Box mb={theme.space.xl}>
              <Text variant={"subHeading1"}>
                Are you sure you want to unblock the driver?
              </Text>
            </Box>
            <Box>
              <Button
                w="100%"
                h="3em"
                color={"#00E267"}
                bg="white"
                border={"1px solid #00E267"}
                borderRadius={"4px"}
                _hover={{ bg: "#00E267", color: "white" }}
                isLoading={unblockedLoading}
                variant="solid"
                size="contain"
                onClick={() => {
                  handleUnblockButton(id as string);
                }}
              >
                Unblock Driver
              </Button>
            </Box>
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

function DeleteModal({
  id,
  isOpen,
  onClose,
  handleDeleteButton,
  deleteLoading,
}: any) {
  const theme = useTheme<Theme>();
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      closeOnOverlayClick={true}
      isCentered={true}
      size="md"
      returnFocusOnClose={false}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton
          sx={{
            borderRadius: "50%",
            background: "transparent",
            top: "5%",
            left: "93%",
            transform: "translate(-100%)",
            width: "3rem",
            height: "3rem",
            color: theme.colors.primary.main,
            //@ts-ignore
            "&:hover": {
              background: "transparent",
            },
          }}
        />
        <ModalBody sx={{ borderRadius: "0.25rem" }}>
          <Box sx={{ margin: "6rem 1.5rem 2.5rem 1.5rem" }}>
            <Box mb={theme.space.xl}>
              <Text variant={"subHeading1"}>
                Are you sure you want to delete the driver?
              </Text>
            </Box>
            <Box>
              <Button
                w="100%"
                h="3em"
                color={theme.colors.primary.main}
                bg="white"
                border={"1px solid"}
                borderColor={theme.colors.primary.main}
                borderRadius={"4px"}
                _hover={{ bg: theme.colors.primary.main, color: "white" }}
                isLoading={deleteLoading}
                variant="solid"
                size="contain"
                onClick={() => {
                  handleDeleteButton(id as string);
                }}
              >
                Delete
              </Button>
            </Box>
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

type DocCardPropType = {
  imageSide: string;
  imageLoaded: boolean;
  image: string | undefined;
};

function DocCard({ imageSide, imageLoaded, image }: DocCardPropType) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  return (
    <>
      <div
        style={{
          flex: "1",
          textAlign: "left",
        }}
      >
        <div
          style={{
            fontSize: "0.65rem",
            marginBottom: "2px",
            color: "#555",
          }}
        >
          {imageSide}
        </div>
        <Skeleton isLoaded={imageLoaded} minH={"9.5rem"} borderRadius="8px">
          <img
            src={image}
            alt="No Image"
            onClick={onOpen}
            style={{
              cursor: "zoom-in",
              width: "100%",
              height: "auto",
              minHeight: "9.5rem",
              borderRadius: "8px",
              border: "1px solid #ccc",
            }}
          />
        </Skeleton>
      </div>
      <ImagePreviewModal isOpen={isOpen} onClose={onClose} image={image} />
    </>
  );
}
